import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const resolveImg = (u) => (u && u.startsWith("/") ? `${BACKEND_URL}${u}` : u);

export const WHATSAPP_NUMBER = "5521987356892";

export const openWhatsApp = (text) => {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  const url = text ? `${base}?text=${encodeURIComponent(text)}` : base;
  window.open(url, "_blank", "noopener,noreferrer");
};

export const WHATSAPP_LEASE_MESSAGE = "Olá! Gostaria de mais informações sobre locação no VM Piabetá.";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CATEGORY_LABELS = {
  anchor: "Lojas e Âncoras",
  container: "Estandes em Contêineres",
  gastronomy: "Gastronomia (Kaven)",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};
